'use strict';

(function () {
    var decodeHtml = function (value) {
        var textarea = document.createElement('textarea');
        textarea.innerHTML = String(value || '');
        return textarea.value;
    };

    var normalizeWhitespace = function (value) {
        return String(value || '')
            .replace(/<br\s*\/?>/gi, ' ')
            .replace(/<\/p>/gi, ' ')
            .replace(/<[^>]+>/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    };

    var createExcerpt = function (value, maxLength) {
        var text = decodeHtml(normalizeWhitespace(value));
        var limit = parseInt(maxLength, 10) || 220;

        if (text.length <= limit) {
            return text;
        }

        var excerpt = text.slice(0, limit);
        var lastSpace = excerpt.lastIndexOf(' ');
        if (lastSpace > 80) {
            excerpt = excerpt.slice(0, lastSpace);
        }

        return excerpt.replace(/[.,;:!\s]+$/, '') + '...';
    };

    var enhanceMethodFinderCards = function () {
        var list = document.getElementById('kh-mf-methods');
        if (!list) {
            return;
        }

        var cards = list.querySelectorAll('.kh-mf-card');
        cards.forEach(function (card) {
            var summaryEl = card.querySelector('.kh-mf-summary');
            if (!summaryEl) {
                return;
            }

            var summaryRaw = summaryEl.getAttribute('data-raw-text');
            if (summaryRaw == null) {
                summaryRaw = summaryEl.textContent || '';
                summaryEl.setAttribute('data-raw-text', summaryRaw);
            }

            var summaryText = normalizeWhitespace(summaryRaw);
            summaryEl.textContent = createExcerpt(summaryText, 220);
        });
    };

    var initMethodFinderCardEnhancements = function () {
        var list = document.getElementById('kh-mf-methods');
        if (!list) {
            return;
        }

        enhanceMethodFinderCards();

        var observer = new MutationObserver(function () {
            enhanceMethodFinderCards();
        });

        observer.observe(list, {
            childList: true
        });
    };

    var initMethodFinderCreateProjectModal = function () {
        var root = document.getElementById('page-innohub-methodenfinder');
        var openBtn = document.getElementById('kh-mf-create-project');
        var modal = document.getElementById('kh-mf-create-project-modal');
        var closeBtn = document.getElementById('kh-mf-create-project-cancel');
        var nameInput = document.getElementById('kh-mf-create-project-name');
        var modalCard = modal ? modal.querySelector('.ih-modal-card') : null;
        var closeBlockedUntil = 0;

        if (!root || !openBtn || !modal || !closeBtn || !modalCard) {
            return;
        }

        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        var isOpen = function () {
            return modal.getAttribute('aria-hidden') === 'false';
        };

        var focusNameInput = function () {
            window.setTimeout(function () {
                if (nameInput) {
                    nameInput.focus();
                }
            }, 0);
        };

        var openModal = function (event) {
            if (event) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
            if (Date.now() < closeBlockedUntil) {
                return;
            }
            modal.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            focusNameInput();
        };

        var closeModal = function (event) {
            if (event) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
            closeBlockedUntil = Date.now() + 300;
            modal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
            if (nameInput) {
                nameInput.value = '';
            }
            window.setTimeout(function () {
                openBtn.blur();
            }, 0);
        };

        openBtn.addEventListener('click', openModal, true);

        closeBtn.addEventListener('mousedown', function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }, true);
        closeBtn.addEventListener('click', closeModal, true);

        modalCard.addEventListener('mousedown', function (event) {
            event.stopPropagation();
        }, true);
        modalCard.addEventListener('click', function (event) {
            event.stopPropagation();
        }, true);

        modal.addEventListener('mousedown', function (event) {
            if (event.target !== modal) {
                return;
            }
            event.preventDefault();
            event.stopImmediatePropagation();
        }, true);
        modal.addEventListener('click', function (event) {
            if (event.target !== modal) {
                return;
            }
            closeModal(event);
        }, true);

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && isOpen()) {
                closeModal(event);
            }
        }, true);
    };

    var initMethodFinderPage = function () {
        initMethodFinderCardEnhancements();
        initMethodFinderCreateProjectModal();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMethodFinderPage);
        return;
    }

    initMethodFinderPage();
}());
